import { Button } from '@douyinfe/semi-ui';
import { IconDownload } from '@douyinfe/semi-icons';
import { useGo } from '../../../../hook/useGo';
import './header.scss';

const AsnGrabberEntry = () => {
  const { go } = useGo();

  const handleOpenGuide = () => {
    go({ path: '/asn-grabber' });
  };

  return (
    <div className='store-ops-header-extension-entry'>
      <Button
        theme='borderless'
        type='primary'
        icon={<IconDownload />}
        onClick={handleOpenGuide}
        className='store-ops-header-extension-entry__link'
      >
        <span className='store-ops-header-extension-entry__text'>抢仓插件</span>
        <span className='store-ops-header-extension-entry__new'>NEW</span>
      </Button>
    </div>
  );
};

export default AsnGrabberEntry;
